var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 8.667H1.333c-.4 0-.666.266-.666.666v5.334c0 .4.266.666.666.666H4c.4 0 .667-.266.667-.666V9.333c0-.4-.267-.666-.667-.666ZM14.667 6H12c-.4 0-.667.267-.667.667v8c0 .4.267.666.667.666h2.667c.4 0 .666-.266.666-.666v-8c0-.4-.266-.667-.666-.667ZM9.333.667H6.667c-.4 0-.667.266-.667.666v13.334c0 .4.267.666.667.666h2.666c.4 0 .667-.266.667-.666V1.333c0-.4-.267-.666-.667-.666Z",
    fill: "#979BA8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphBar);
export default __webpack_public_path__ + "static/media/graph-bar.301dac4bc166a6d4f56b950557a1936e.svg";
export { ForwardRef as ReactComponent };